export default function (state) {
    let form = state;
    let data = {};
    if (form.dateType > 1) form.dateType = 1;
    data.dateType = form.dateType;
    data.loadType = form.loadType;
    data.accountId = form.accountId;
    data['paginationInfo.CurrentPage'] = 1;
    data['paginationInfo.ItemsPerPage'] = 10000;
    data['fromDate.Serialized'] = form.dates[0];
    data['toDate.Serialized'] = form.dates[1];
    return data;
}